<!-- @format -->

<div class="hmf-display-flex">
	@if (thumbnailImageConfigs().length) {
		<a [href]="basePDPUrl()" class="hmf-display-flex thumbs hmf-mr-xxs hmf-mr-md-xxs">
			@for (imageConfig of thumbnailImageConfigs(); track imageConfig.loaderParams.swatchColor) {
				<div class="thumb-container">
					<shared-media-component-optimized-image
						[imageLoaderConfig]="imageConfig"
						[altText]="`${product().name} ${imageConfig.loaderParams.swatchColor} thumbnail`"
					></shared-media-component-optimized-image>
				</div>
			}
		</a>
	}
	<!-- use display classes instead of breakpoints to avoid CLS issues -->
	<a hmf-text-link [linkURL]="basePDPUrl()" variant="tertiary" size="small" classList="hmf-display-md-none hmf-display-inline">See All Options</a>
	<a hmf-text-link [linkURL]="basePDPUrl()" variant="tertiary" size="medium" classList="hmf-display-md-inline hmf-display-none">See All Options</a>
</div>
